import { Injectable, Injector } from "@angular/core";
import { SharedService } from "./shared.service";
import { OutlookService } from "./outlook/outlook.service";

@Injectable({
    providedIn: "root"
})
export class UnsafeFileService {
    preferenceKey = "UnsafeFileTypes";
    files = ["msi","exe","com","bat","cmd","ps1","dll","scr","ocx","vbs","js"];
    private isConfigured = false;

    constructor(private readonly injector: Injector, private readonly outlookService: OutlookService) {
    }

    private ensureConfigured(): void {
        if (this.isConfigured) {
            return;
        }

        const sharedService = this.injector.get(SharedService, null);
        const preferences = sharedService?.currentPreferencesDialogState?.Preferences;
        const preference = preferences?.find(value => value.Key === this.preferenceKey);

        if (preference?.Value) {
            this.files = preference.Value.split(",").map(ext => ext.trim()).filter(ext => !!ext);
        }

        this.isConfigured = true;
    }

    public isSafe(filename: string): boolean{
        this.ensureConfigured();

        const match = /\.([0-9a-z]+)$/i.exec(filename);
        if (match) {
            const extension = match[1];
            return this.files.indexOf(extension) === -1;
        } else {
            // file has no extension
            return true;
        }
    }

    public validateAttachments(): boolean {
        const attachments = this.outlookService.attachments
            .filter(att => !att.isInline)
            .filter(att => !this.isSmimeAttachment(att));
        if(attachments && attachments.length > 0){
          const results = attachments.map(attach => this.isSafe(attach.name));

          return results.indexOf(false) === -1;
        }
        return true;
    }

    private isSmimeAttachment(attachment: Office.AttachmentDetails): boolean {
        const name = (attachment.name ?? "").toLowerCase();
        return name.endsWith(".p7s") || name.endsWith(".p7m");
    }
}
